import { useStyles } from "./styles";
import { Button, Row, Col, Form, FormCheck } from "react-bootstrap";
import { TextField } from "@components/FormsV2";
import FormFieldLabel from "@components/Forms/FormFieldLabel/FormFieldLabel";
import { useState } from "react";

const Custom = () => {
  const styles = useStyles();
  const [isValid, setIsValid] = useState<boolean>(false);

  const [name, setName] = useState<string>("");
  const [description, setDescription] = useState<string>("");
  const [mfrPartNumber, setMfrPartNumber] = useState<string>("");
  const [productId, setProductId] = useState<string>("");
  const [sku, setSku] = useState<string>("");
  const [category, setCategory] = useState<string>("");
  const [subcategory, setSubcategory] = useState<string>("");
  const [quantity, setQuantity] = useState<number>(1);
  const [unitOfMeasure, setUnitOfMeasure] = useState<string>("");
  const [unitPrice, setUnitPrice] = useState<string>("");
  const [unitCost, setUnitCost] = useState<string>("");
  const [listPrice, setListPrice] = useState<string>("");
  const [vendorDiscount, setVendorDiscount] = useState<string>("");
  const [markup, setMarkup] = useState<string>("");

  //true if "Manage Unit Price" checked, otherwise false
  const [manageUnitPrice, setManageUnitPrice] = useState<boolean>(true);

  return (
    <div className={styles.card}>
      <div className={styles.cardHeader}>
        <div className={styles.actionButtons}>
          <Button
            className={styles.cancelButton}
            onClick={(e) => {
              const previousPage = window.location.href
                .split("/")
                .slice(0, -1)
                .join("/");
              window.location.replace(previousPage);
            }}
          >
            Cancel
          </Button>
          <h2>Add Custom Product</h2>
        </div>

        <div className={styles.actionButtons}>
          <Button
            className={`${styles.button} ${styles.addAnotherBtn} ${
              isValid ? "" : styles.disabled
            }`}
            onClick={() => null}
          >
            Save & Add Another
          </Button>
          <Button
            className={`${styles.button} ${isValid ? "" : styles.disabled}`}
            onClick={() => null}
          >
            Save
          </Button>
        </div>
      </div>
      <div>
        <div className={styles.formSection}>
          <div className={styles.sectionHeader}>Identifier</div>
          <Row>
            <Col>
              <TextField
                label="*Name"
                id="name"
                placeholder="Enter product name"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </Col>
            <Col>
              <TextField
                label="Description"
                id="description"
                placeholder="Enter product description"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <TextField
                label="Manufacturer Part Number"
                id="mfrPartNumber"
                placeholder="Enter manufacturer part number"
                value={mfrPartNumber}
                onChange={(e) => setMfrPartNumber(e.target.value)}
              />
            </Col>
            <Col>
              <TextField
                label="Internal Product Id"
                id="productId"
                placeholder="Enter internal product id"
                value={productId}
                onChange={(e) => setProductId(e.target.value)}
              />
            </Col>
            <Col>
              <TextField
                label="Vendor SKU"
                id="sku"
                placeholder="Enter vendor sku"
                value={sku}
                onChange={(e) => setSku(e.target.value)}
              />
            </Col>
          </Row>
        </div>
        <div className={styles.formSection}>
          <div className={styles.sectionHeader}>Classification</div>
          <Row>
            <Col>
              <TextField
                label="Category"
                id="category"
                placeholder="Enter category"
                value={category}
                onChange={(e) => setCategory(e.target.value)}
              />
            </Col>
            <Col>
              <TextField
                label="Sub-category"
                id="subcategory"
                placeholder="Enter sub-category"
                value={subcategory}
                onChange={(e) => setSubcategory(e.target.value)}
              />
            </Col>
          </Row>
        </div>
        <div className={styles.formSection}>
          <div className={styles.sectionHeader}>Quantity</div>
          <Row>
            <Col>
              <FormFieldLabel label="*Quantity" className="" />
              <Form.Control
                required={true}
                placeholder="Enter quantity"
                value={quantity}
                onChange={(e) => setQuantity(parseInt(e.target.value))}
                type="number"
                min={0}
                step={0.01}
              />
            </Col>
            <Col>
              <TextField
                label="Unit of Measure"
                id="units"
                placeholder="Enter unit of measure"
                value={unitOfMeasure}
                onChange={(e) => setUnitOfMeasure(e.target.value)}
              />
            </Col>
          </Row>
        </div>
        <div className={styles.pricing}>
          <div className={styles.sectionHeader}>Price</div>
          <Row>
            <Col sm={3}>
              <Form.Check
                type="radio"
                label="Manage Unit Price"
                name="priceOption"
                checked={manageUnitPrice}
                onChange={() => setManageUnitPrice(true)}
                className={`${styles.radioOption} ${
                  manageUnitPrice ? styles.selected : ""
                }`}
              />
              <Form.Check
                type="radio"
                label="Manage List Price"
                name="priceOption"
                checked={!manageUnitPrice}
                onChange={() => setManageUnitPrice(false)}
                className={`${styles.radioOption} ${
                  !manageUnitPrice ? styles.selected : ""
                }`}
              />
            </Col>
            <Col sm={9}>
              {manageUnitPrice ? (
                <Row>
                  <Col>
                    <FormFieldLabel label="Unit Price" className="" />
                    <Form.Control
                      placeholder="Enter unit price"
                      value={unitPrice}
                      onChange={(e) => setUnitPrice(e.target.value)}
                      type="number"
                      min={0}
                      step={0.01}
                    />
                  </Col>
                  <Col>
                    <FormFieldLabel label="Unit Cost" className="" />
                    <Form.Control
                      placeholder="Enter unit cost"
                      value={unitCost}
                      onChange={(e) => setUnitCost(e.target.value)}
                      type="number"
                      min={0}
                      step={0.01}
                    />
                  </Col>
                </Row>
              ) : (
                <Row>
                  <Col>
                    <FormFieldLabel label="List Price" className="" />
                    <Form.Control
                      placeholder="Enter list price"
                      value={listPrice}
                      onChange={(e) => setListPrice(e.target.value)}
                      type="number"
                      min={0}
                      step={0.01}
                    />
                  </Col>
                  <Col>
                    <FormFieldLabel label="Vendor Discount" className="" />
                    <Form.Control
                      placeholder="Enter vendor discount"
                      value={vendorDiscount}
                      onChange={(e) => setVendorDiscount(e.target.value)}
                      type="number"
                      min={0}
                      step={0.01}
                    />
                  </Col>
                  <Col>
                    <FormFieldLabel label="Markup (%)" className="" />
                    <Form.Control
                      placeholder="Enter markup"
                      value={markup}
                      onChange={(e) => setMarkup(e.target.value)}
                      type="number"
                      min={0}
                      step={0.01}
                    />
                  </Col>
                </Row>
              )}
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};

export default Custom;
